import React from 'react';
import { StreakMilestone } from '../../../api/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { stripHtml } from '../../../util';
import './MilestoneBadges.css';

interface MilestoneBadgesProps {
    milestones: StreakMilestone[];
    currentStreak: number;
    nextMilestoneWeeks: number | null;
}

const MilestoneBadges: React.FC<MilestoneBadgesProps> = ({ milestones, currentStreak, nextMilestoneWeeks }) => {
    if (!milestones || milestones.length === 0) return null;

    const achieved = milestones.filter(m => m.achieved);
    const nextMilestone = nextMilestoneWeeks !== null
        ? milestones.find(m => m.weekThreshold === nextMilestoneWeeks)
        : null;

    if (achieved.length === 0 && !nextMilestone) return null;

    const percent = nextMilestone
        ? Math.min(100, Math.round((currentStreak / nextMilestone.weekThreshold) * 100))
        : 0;
    const weeksToGo = nextMilestone ? Math.max(0, nextMilestone.weekThreshold - currentStreak) : 0;

    return (
        <div className="milestone-badges-container">
            {achieved.length > 0 && (
                <div className="milestone-achieved-list">
                    {achieved.map(m => (
                        <div key={m.weekThreshold} className="milestone-achieved-badge" title={stripHtml(m.message)}>
                            <div className="milestone-achieved-icon">
                                <FontAwesomeIcon icon={faTrophy} />
                            </div>
                            <div className="milestone-achieved-weeks">{m.weekThreshold}w</div>
                        </div>
                    ))}
                </div>
            )}

            {nextMilestone && (
                <div className="next-milestone-card">
                    <div className="next-milestone-header">
                        <div className="next-milestone-icon">
                            <FontAwesomeIcon icon={faTrophy} />
                        </div>
                        <div className="next-milestone-info">
                            <div className="next-milestone-label">Next milestone</div>
                            <div className="next-milestone-name">{stripHtml(nextMilestone.message)}</div>
                        </div>
                        <div className="next-milestone-percent">{percent}%</div>
                    </div>
                    <div className="next-milestone-bar">
                        <div className="next-milestone-bar-fill" style={{ width: `${percent}%` }} />
                    </div>
                    <div className="next-milestone-footer">
                        <span>{currentStreak} / {nextMilestone.weekThreshold} weeks</span>
                        <span>{weeksToGo} week{weeksToGo === 1 ? '' : 's'} to go</span>
                    </div>
                    {nextMilestone.rewardName && (
                        <div className="next-milestone-reward">
                            Milestone reward: <strong>{stripHtml(nextMilestone.rewardName)}</strong>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MilestoneBadges;
